import { AudienceAggregatedData } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<AudienceAggregatedData>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminEventRegistrantsStatsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminRegistrantsStats.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getAdminRegistrantsStats.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getAdminRegistrantsStats.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getAdminRegistrantsStats.reset.type]: actionsHandlers.handleGetOneReset,
});

export default adminEventRegistrantsStatsReducer;
